

























































































































































import { TranslateResult }                                                           from 'vue-i18n';
import { ElForm }                                                                    from 'element-ui/types/form';
import { GlobalContexts, useGlobals }                                                from '@/hooks/use-globals';
import { getRegisterViewStorePath, getViewStorePath }                                from '@/store/store.helpers';
import { computed, defineComponent, onBeforeMount, onUnmounted, reactive, Ref, ref } from '@vue/composition-api';
import cButton                                                                       from '@/components/form/button/button.component.vue';
import cForm                                                                         from '@/components/form/form/form.component.vue';
import cFormItem                                                                     from '@/components/form/form-item/form-item.component.vue';
import cInput                                                                        from '@/components/form/input/input.component.vue';
import cDatePicker                                                                   from '@/components/form/date-picker/date-picker.component.vue';
import cSelect                                                                       from '@/components/form/select/select.component.vue';
import cOption                                                                       from '@/components/form/option/option.component.vue';
import { Computed, ObjectWithStringKeys, ValidationRule }                            from '@/types';
import cBreadcrumb                                                                   from '@/components/breadcrumb/breadcrumb.component.vue';
import cSwitch                                                                       from '@/components/form/switch/switch.component.vue';
import { Form, Impacts }                                                             from '@/views/events/submodules/events-detail.types';
import { useEventDetailRules }                                                       from '@/views/events/submodules/hooks/use-event-detail-rules.hook';
import { Impact }                                                                    from '@/helpers/variables';
import { EventTypes }                                                                from '@/views/events/events.types';
import { name as vEvents, path as eventsBasePath }                                   from '../events.route';
import { name }                                                                      from './events-detail.route';

export default defineComponent({
  name: 'vEventsDetail',
  components: {
    cBreadcrumb,
    cSwitch,
    cForm,
    cFormItem,
    cButton,
    cInput,
    cDatePicker,
    cSelect,
    cOption,
  },
  setup(props, context) {
    const { store, i18n, router }: GlobalContexts = useGlobals();
    const eventUuid: Computed<string | undefined> = computed(() => context.root.$route.params.eventUuid);
    const getTranslation = (value: string): string => ref(i18n.t(`vEventsDetail.${value}`)).value.toString();
    const getImpactTranslation = (value: string): string => ref(i18n.t('vEventsDetail.form.impactFor', [ value ])).value.toString();
    const getFormTranslation = (value: string): string => ref(i18n.t(`vEventsDetail.form.${value}`)).value.toString();
    const getBreadcrumbTranslation: Computed<TranslateResult> = computed(() => i18n.t('vEventsDetail.meta.breadcrumb'));
    const SWITCH_PRIMARY: string = getComputedStyle(document.body).getPropertyValue('--switch-color');
    const formRef: Ref<ElForm> = ref({});
    const formFields: Form = reactive(store.state.views?.vEventsDetail.form);
    const switchValue: { internal: boolean } = reactive(store.state.views?.vEventsDetail.switch);
    const impacts: Computed<Impacts[]> = computed(() => store.state.views?.vEventsDetail.form.impacts as Impacts[]);
    const loading: Computed<boolean> = computed(() => store.state.views?.vEventsDetail.loading as boolean);
    const removeSpaces = (text: string) => text.replace(/\s/g, '-').toLowerCase();

    const onSubmit = (): void => {
      formRef.value.validate(async (valid: boolean) => {
        if (valid) {
          if (eventUuid.value) {
            await store.dispatch(`${getViewStorePath(name)}/submitEvent`, eventUuid.value);

            if (store.hasModule(getRegisterViewStorePath(vEvents))) {
              await store.dispatch((`${getViewStorePath(vEvents)}/getEvents`));
            }
          } else {
            await store.dispatch(`${getViewStorePath(name)}/submitEvent`);

            if (store.hasModule(getRegisterViewStorePath(vEvents))) {
              await store.dispatch((`${getViewStorePath(vEvents)}/getEvents`));
            }
            await router.push({ name: vEvents });
          }
        }
      });
    };

    const rules: Computed<ObjectWithStringKeys<ValidationRule[]>> = computed(() => useEventDetailRules(impacts));

    const onDateRangeChange = (dateRange: Array<string>): void => {
      store.commit(`${getViewStorePath(name)}/setImpactsList`, dateRange);
    };

    const onMassImpactChange = (massImpact: string): void => {
      store.commit(`${getViewStorePath(name)}/setMassImpact`, massImpact);
    };

    onUnmounted(() => {
      store.unregisterModule([ 'views', name ]);
    });

    onBeforeMount(() => {
      context.root.$route.meta.breadcrumb = [
        { name: 'events', path: eventsBasePath },
        { name: eventUuid.value ? 'edit' : 'create', path: '' },
      ];

      if (eventUuid.value) {
        store.dispatch(`${getViewStorePath(name)}/getOneEvent`, eventUuid.value);
      }
    });

    return {
      getTranslation,
      getFormTranslation,
      getImpactTranslation,
      getBreadcrumbTranslation,
      formRef,
      formFields,
      onSubmit,
      EVENT_TYPES: Object.values(EventTypes),
      IMPACT_TYPES: Object.values(Impact),
      rules,
      switchValue,
      SWITCH_PRIMARY,
      onDateRangeChange,
      impacts,
      onMassImpactChange,
      vEvents,
      loading,
      eventUuid,
      removeSpaces,
    };
  },
});
